export default "__VITE_ASSET__3f243f54__"